import { PlayIcon } from '@heroicons/react/24/outline';
import { Link } from 'react-router';

const PathwayNavigator = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm border px-4 py-3">
      <div className="font-semibold text-sm text-slate-800 mb-0.5">Navigator</div>
      <div className="text-xs text-slate-400 leading-relaxed mb-2">
        Discover and analyze decarbonization pathways from our curated library.
      </div>
      <Link to="/pathway-navigator" className="btn btn-accent btn-xs">
        <PlayIcon className="h-4 w-4" />
        Explore Pathways
      </Link>
    </div>
  );
};

export default PathwayNavigator;
